module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/ig-04-6ce01c1c26a1015af5073ed83ccefb2f.jpg";